import appConf from "@/config/config.js";
import Papa from "papaparse";
import { ref } from "vue";

const getCSV = (filename) => {
  const url = appConf.csvDir + filename + ".csv";
  const retAr = ref([]);
  
  const load = async (retFunc = false) => {
    Papa.parse(url, {
      download: true,
      encoding: "UTF8",
      skipEmptyLines: true,
      complete: function (results) {
        results.data.forEach((row) => {
          let retRow = {};
          if(!row[1] && !row[0]){
            return;
          }
          row.forEach((cell, i) => {
            let key = i == row.length - 1 ? "name" : i;
            retRow[key] =cell;
          });
          if (retRow.name.includes("!")) {
            retRow.name = retRow.name.replace("!", "");
            retRow.headerOption = true;
          }
          retAr.value.push(retRow);
        });
        if(retFunc){
          retFunc();
        }
      },
      error: function (err, file, inputElem, reason) {
        console.log(err, file, inputElem, reason);
      },
    });
  };
  return { load, retAr };
};

export default getCSV;
